<template>
  <div v-bind="$attrs" class="pagination-content">
    <a-pagination
      :total="totalCount"
      :page-size="pagination.pageSize"
      show-size-changer
      show-quick-jumper
      :show-total="
        (total) =>
          `${$t('message.commonUsage.total')} ${total} ${$t(
            'message.commonUsage.records'
          )}`
      "
      :current="pagination.curPage"
      @change="paginationChange"
      @showSizeChange="onShowSizeChange"
      :page-size-options="pageSizeOptions"
    />
  </div>
</template>
<script>
export default {
  name: "MyPagination",
  components: {},
  props: {
    total: Number,
    immediately: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      pagination: {
        curPage: 1,
        pageSize: 12,
      },
      totalCount: this.total,
      pageSizeOptions: ["12", "24", "48"],
    };
  },
  computed: {},
  watch: {
    total(v) {
      this.totalCount = v;
    },
  },
  mounted() {
    if (this.immediately) {
      this.$emit("change", this.pagination);
    }
  },
  methods: {
    paginationChange(current) {
      this.pagination.curPage = current;
      this.$emit("change", this.pagination);
    },
    onShowSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize;
      this.initCurrent();
      this.$emit("change");
    },
    initCurrent() {
      this.pagination.curPage = 1;
    },
  },
};
</script>

<style scoped lang="less">
.pagination-content {
  padding-top: 10px;
}
</style>
